module.exports = __webpack_public_path__ + "img/ultra_2_05.2621f9ee.jpg";